import { combineReducers } from '@reduxjs/toolkit';
import state from './stateSlice';

const reducer = combineReducers({
	state
});
export default reducer;
